export const RECORD_ADDED_SUCCESSFULLY = 'RECORD ADDED SUCCESSFULLY !';
export const RECORD_UPDATE_SUCCESSFULLY = 'RECORD UPDATE SUCCESSFULLY !';
export const RECORD_DELETE_SUCCESSFULLY = 'RECORD DELETE SUCCESSFULLY !';

export const OFFER_AND_DEMAND = {
  OFFERS: 'Offers',
  DEMANDS: 'Demands',
};

export const TYPE_OF_OFFER_AND_DEMAND_TAB_HEADING = {
  LIVE: 'Live',
  FORWARD: 'Forward',
  FOREIGN: 'Foreign',
  INACTIVE: 'Inactive',
};

export const TYPE_OF_OFFER_AND_DEMAND_TAB_HEADING_WITHOUT_INACTIVE = {
  LIVE: 'Live',
  FORWARD: 'Forward',
  FOREIGN: 'Foreign',
};

export const TYPE_OF_OFFER_AND_DEMAND = {
  LIVE: 'LIVE',
  FORWARD: 'FORWARD',
  FOREIGN: 'FOREIGN',
};

export const OFFER_AND_DEMAND_OPTION = [
  { id: 'LIVE', label: 'LIVE' },
  { id: 'FORWARD', label: 'FORWARD' },
  { id: 'FOREIGN', label: 'FOREIGN' },
];

export const BID_ORDER_OPTION = [
  { id: 'OFFER', label: 'OFFER' },
  { id: 'DEMAND', label: 'DEMAND' },
];
